import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/app/hooks";
import { visibility } from "../../redux/slices/rightSideAd";
import "./Help.scss";
import { useNavigate } from "react-router-dom";
import { FETCH_POLICY, SCHOOL_ADMIN, STUDENT_ROLE, TEACHER_ROLE } from "../../utils/constants";
import { GET_VERSION } from "./api/Help";
import { useQuery } from "@apollo/client";
import Loader from "../../components/Loader/Loader";
import { getAppVersion } from "../../utils/helper";
import MobileHeader from "../../components/MobileHeader/MobileHeader";

export interface Version {
  appName: string,
  appVersion: string
}
export interface  VersionNode{
  nodes: [Version]
}
export interface VersionResponse{
  allVersions: VersionNode
}
const Help = () => {
  const role = useAppSelector((state) => state.auth.role);
  const dispatch = useAppDispatch();
  dispatch(visibility({ isVisible: role === SCHOOL_ADMIN ? true : false }));
  const navigate = useNavigate();

  const [appVersion, setAppVersion] = useState<string | null>(null);

  const fetchAppVersion = async () => {
    try {
      const version = await getAppVersion();
      console.log("version is", version);
      setAppVersion(version);
    } catch (error) {
      console.error("Failed to fetch app version:", error);
    }
  };

  useEffect(() => {
    fetchAppVersion();
  }, []);
  
  const {
    data : version,
    loading
  } = useQuery<VersionResponse>(GET_VERSION,{
    variables: { platformtype: 'EXE' },
    fetchPolicy: FETCH_POLICY,
    notifyOnNetworkStatusChange: true,
  });

  console.log("app version is", appVersion);
  console.log("version is outside", version);

  return (
    <div className="HelpCtn">
      { loading ? <Loader/>:
        <>
        <div className="helpMobileHeaderContainer">
          <div className="mobileHelpTitleTextStyle">Help</div>
          <MobileHeader/>
        </div>
        <div className="detailsCtn">
          <div className="AppName">{version?.allVersions?.nodes[0]?.appName}</div>
          <span className="version">Version {version?.allVersions?.nodes[0].appVersion}</span>
        </div>
        <span className="line"></span>
        <h4 className="helpMenu"
        onClick={()=> 
          navigate(role === SCHOOL_ADMIN 
                  ? "/admin-help/help-center" 
                  : role === TEACHER_ROLE 
                    ? "/teacher-help/help-center" 
                    : role === STUDENT_ROLE 
                      ? "/student-help/help-center" 
                      : "" 
          )}>
          Help Center
          </h4>
        <span className="line"></span>
        <h4
          className="helpMenu"
          onClick={() => 
            navigate(role === SCHOOL_ADMIN 
                    ? "/admin-help/admin-terms-and-privacy-policy" 
                    : role === TEACHER_ROLE 
                      ? "/teacher-help/teacher-terms-and-privacy-policy" 
                      : role === STUDENT_ROLE 
                        ? "/student-help/student-terms-and-privacy-policy" 
                        : "" 
            )}
        >
          Terms and Privacy Policy
        </h4>
        </>
      }
    </div>
  );
};

export default Help;
